import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

const FormTextarea = ({ customKey, register, config, errors, hasMounted, isLoading = false }) => {
    return (
        <div key={customKey} className="form-control flex flex-col col-span-1 md:col-span-2">
            {config.label && (
                <label htmlFor={config.name} className="label-text">
                    {config.label}{" "}
                    {config.info && (
                        <div className="tooltip" data-tip={config.info}>
                            <FontAwesomeIcon icon={faCircleInfo} className="text-primary" />
                        </div>
                    )}
                </label>
            )}

            <div className={`${errors ? "tooltip" : ""}`} data-tip={errors?.message}>
                {/* tailwind classes for dynamic height h-7 h-13 h-19 h-25 h-31 h-37 */}
                {isLoading ? (
                    <div
                        className={`bg-gradient-to-r from-base-300 via-base-200 to-base-300 bg-[length:400%_100%] rounded-lg w-full animate-[pulse_1s_ease-in-out_infinite_alternate] border border-base-300 h-${(config?.rows || 3) * 6 + 1}`}
                    ></div>
                ) : (
                    <textarea
                        className={`textarea text-left w-full disabled:bg-disabled disabled:text-disabled-content placeholder-disabled-content ${hasMounted ? "transition-all duration-300 ease-in-out" : ""}
                            ${errors ? "textarea-error disabled:textarea-error" : "textarea-primary"}`}
                        type={config.type}
                        id={config.name}
                        defaultValue={config.defaultValue}
                        placeholder={config.placeholder}
                        disabled={config.disabled}
                        rows={config?.rows}
                        {...register(
                            config.name,
                            config.validators
                                ? config.validators
                                : {
                                      required: false,
                                      pattern: false,
                                      validate: false,
                                      minLength: 0,
                                      maxLength: Infinity,
                                  },
                        )}
                    />
                )}
            </div>
        </div>
    );
};

export default FormTextarea;
